import { render, staticRenderFns } from "./13_Dependents.vue?vue&type=template&id=d2c4667c&scoped=true&"
import script from "./13_Dependents.vue?vue&type=script&lang=js&"
export * from "./13_Dependents.vue?vue&type=script&lang=js&"
import style0 from "./13_Dependents.vue?vue&type=style&index=0&id=d2c4667c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2c4667c",
  null
  
)

export default component.exports